import { render, staticRenderFns } from "./FramesToTs.vue?vue&type=template&id=8a29a932&scoped=true"
import script from "./FramesToTs.vue?vue&type=script&lang=js"
export * from "./FramesToTs.vue?vue&type=script&lang=js"
import style0 from "./FramesToTs.vue?vue&type=style&index=0&id=8a29a932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a29a932",
  null
  
)

export default component.exports